//removeIf(production)
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './WaitTimesCSS.css';
//endRemoveIf(production)
class WaitTimesComponent extends Component {
    constructor(props) {
        super(props);
        const isSpanish = window.location.pathname.slice(0, 4) === '/es' || window.location.pathname.slice(0, 4) === '/es/';

        this.state = {
            isSpanish,
            title: isSpanish ? 'Tiempos de espera de seguridad actuales' : 'Security Wait Times',
            title2: isSpanish ? 'Horas de TSA Pre-Check' : 'TSA Pre-Check Hours',
            t2: 'Terminal 2',
            t3: 'Terminal 3',
            t4a: isSpanish ? 'Terminal 4 - Puertas A' : 'Terminal 4 - A Gates',
            t4b: isSpanish ? 'Terminal 4 - Puertas B' : 'Terminal 4 - B Gates',
            t4c: isSpanish ? 'Terminal 4 - Puertas C' : 'Terminal 4 - C Gates',
            t4d: isSpanish ? 'Terminal 4 - Puertas D' : 'Terminal 4 - D Gates',
            'T4B': { "projectedWaitTime": 5 },
            'T4C': { "projectedWaitTime": 5 },
            'T4D': { "projectedWaitTime": 5 },
            'T2': { "projectedWaitTime": 5 },
            'T4A': { "projectedWaitTime": 5 },
            'T3': { "projectedWaitTime": 5 }
        }
    }

    componentDidMount() {
        this.fetchTimes();
        this.refresher = setInterval(this.fetchTimes, 60 * 1000);
    }

    componentWillUnmount() {
        clearInterval(this.refresher)
    }

    fetchTimes = () => {
        fetch("https://services.skyharbor.com/CheckPointWaitTimes", {
            //fetch("https://apps.skyharbor.com/waittimessita", {
        }).then(data => data.json())
            .then(body => {
                let newState = {};
                body.current.forEach(item => {
                    if (item.projectedWaitTime < 1) {
                        item.projectedWaitTime = 'Closed';
                    } else {
                        let postFix = ' min';
                        let initialWaittime = Math.round(item.projectedWaitTime / 60);

                        if (initialWaittime >= 60 && initialWaittime < 1440) {
                            postFix = ' h';
                            initialWaittime = Math.round(initialWaittime / 60)

                        }
                        if (initialWaittime >= 1440 && initialWaittime < 525600) {
                            postFix = ' d';
                            initialWaittime = Math.round(initialWaittime / 1140)

                        }
                        if (initialWaittime > 525600) {
                            postFix = ' yr';
                            initialWaittime = Math.round(initialWaittime / 525600)

                        }
                        item.projectedWaitTime = initialWaittime + postFix;
                    }
                    switch (item.queueName) {
                        case 'T2 General':
                            Object.assign(newState, { 'T2': item });
                            break;
                        case 'T3 General':
                            Object.assign(newState, { 'T3': item });
                            break;
                        case 'T4 Checkpoint A General':
                            Object.assign(newState, { 'T4A': item });
                            break;
                        case 'T4 Checkpoint B General':
                            Object.assign(newState, { 'T4B': item });
                            break;
                        case 'T4 Checkpoint C General':
                            Object.assign(newState, { 'T4C': item });
                            break;
                        case 'T4 Checkpoint D General':
                            Object.assign(newState, { 'T4D': item });
                            break;
                        default:
                            break;

                    }
                });
                return newState;
            }).then(newState => this.setState(newState));
    };

    render() {
        return (
            <div className="BlueBox  mx-md-0">
                <div className="col-12 mt-2 p-2">
                    <div className="col-12 mt-2 pl-0 WTHeader">
                        <span className="mx-2">{this.state.title}</span>
                    </div>
                </div>


                {/* <div className="col-12 WTInvRow ">
                    <div className="row">
                        <div className="col-8 WTMinutes">
                            <span>Terminal 2</span>
                        </div>
                        <div className="col-4 WTMinutes text-right">
                            <span>{this.state.T2.projectedWaitTime}</span>
                        </div>
                    </div>
                </div> */}
                <div className="col-12 WTInvRow ">
                    <div className="row">
                        <div className="col-8 WTMinutes">
                            <span>Terminal 3</span>
                        </div>
                        <div className="col-4 WTMinutes text-right">
                            <span>{this.state.T3.projectedWaitTime}</span>
                        </div>
                    </div>
                </div>
                <div className="col-12 WTInvRow ">
                    <div className="row">
                        <div className="col-8 WTMinutes">
                            <span>{this.state.t4a}</span>
                        </div>
                        <div className="col-4 WTMinutes text-right">
                            <span>{this.state.T4A.projectedWaitTime}</span>
                        </div>
                    </div>
                </div>
                <div className="col-12 WTInvRow ">
                    <div className="row">
                        <div className="col-8 WTMinutes">
                            <span>{this.state.t4b}</span>
                        </div>
                        <div className="col-4 WTMinutes text-right">
                            <span>{this.state.T4B.projectedWaitTime}</span>
                        </div>
                    </div>
                </div>
                <div className="col-12 WTInvRow ">
                    <div className="row">
                        <div className="col-8 WTMinutes">
                            <span>{this.state.t4c}</span>
                        </div>
                        <div className="col-4 WTMinutes text-right">
                            <span>{this.state.T4C.projectedWaitTime}</span>
                        </div>
                    </div>
                </div>
                <div className="col-12 WTInvRow ">
                    <div className="row">
                        <div className="col-8 WTMinutes">
                            <span>{this.state.t4d}</span>
                        </div>
                        <div className="col-4 WTMinutes text-right">
                            <span>{this.state.T4D.projectedWaitTime}</span>
                        </div>
                    </div>
                </div>


                <div className="col-12 p-2">
                    <div className="col-12 pl-0 WTHeader">
                        <span className="mx-2">{this.state.title2}</span>
                    </div>
                </div>
                <div className="col-12 pb-2">
                    <div className="row tsa-precheck-row-border">
                        <div className="col-4">
                            <div className="row h-100 tsa-precheck-right-border" style={{ letterSpacing: '1px', lineHeight: '1.9' }}>
                                <div className="col-12  px-0 tsa-times tsa-precheck-box text-center">
                                    <div className="col"><span style={{
                                        borderBottom: 'solid',
                                        borderColor: "rgba(133, 183, 217, 1)"
                                    }}>Terminal 3</span></div>

                                </div>
                                <div className="col-12 px-0 tsa-times tsa-precheck-box text-center">
                                    5 a.m. - 2 p.m.

                                </div>

                            </div>
                        </div>
                        {/* end terminal 2 terminal 3*/}

                        <div className="col-8 h-100">
                            <div className="row">
                                <div className="tsa-precheck-box w-100" style={{ letterSpacing: '1px', lineHeight: '1.9' }}>
                                    <div className="col-12 tsa-times text-left">
                                        <span
                                            style={{
                                                borderBottom: 'solid',
                                                borderColor: "rgba(133, 183, 217, 1)"
                                            }}>Terminal 4</span>

                                    </div>
                                    <div className="col-12 tsa-times text-left">
                                        Checkpoint A - 5 a.m. - 7 p.m.
                                    </div>
                                    <div className="col-12 tsa-times text-left">
                                        {/* Checkpoint B - 5 a.m. - 7 p.m. */}
                                        Checkpoint B - Closed
                                    </div>
                                    <div className="col-12 tsa-times text-left">
                                        Checkpoint C - 5 a.m. - 7 p.m.
                                    </div>
                                    <div className="col-12 tsa-times text-left">
                                        {/* Checkpoint D - 5 a.m. - 7 p.m. */}
                                        Checkpoint D - Closed
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


let domContainer = document.querySelector('#wait_time_widget');
if (!(domContainer === undefined || domContainer === null) === true) ReactDOM.render(<WaitTimesComponent />, domContainer);
